export const BUSINESS = {
    name: "Farakka Broadband",
    phone: "9933719744",
    phoneDisplay: "9933719744",
    tel: "tel:9933719744",
    extraPhones: ["9153422466"],
    gst: "19AHTPH8447E1ZT",
    addressLines: [
        "Vill- Paikpara,",
        "P.O- Beniagram,",
        "Dist- Murshidabad,",
        "PIN- 742212,",
        "West Bengal, India",
    ],
    addressShort: "Paikpara, Beniagram, Murshidabad, West Bengal – 742212",
    mapQuery: "Paikpara, Beniagram, Murshidabad, West Bengal 742212",
    address2Lines: [
        "N.H 34, New Farakka,",
        "Opposite Indian Oil Petrol",
        "(Ghusia Pump),",
        "Murshidabad, West Bengal",
    ],
    address2Short: "NH 34, New Farakka (Opp. Indian Oil Petrol, Ghusia Pump)",
    mapQuery2: "Indian Oil Petrol Pump, Ghusia, NH 34, Farakka, West Bengal",
};

export const NAV_LINKS = [
    { label: "Home", href: "home" },
    { label: "About", href: "about" },
    { label: "Products", href: "products" },
    { label: "Services", href: "services" },
    { label: "Solar", href: "solar" },
    { label: "CCTV", href: "cctv" },
    { label: "Contact", href: "contact" },
];

export const QUICK_FEATURES = [
    { icon: "zap", label: "Power Backup" },
    { icon: "sun", label: "Solar Solutions" },
    { icon: "video", label: "CCTV Security" },
    { icon: "wifi", label: "Broadband Connection" },
];

export const PRODUCTS = [
    {
        id: "smarten-inverter",
        name: "Smarten Inverter",
        description:
            "Reliable inverter solutions for dependable power backup at home and work.",
        cta: "Enquire Now",
        art: "inverter",
        accent: "#00CFFF",
        category: "Power Backup",
    },
    {
        id: "inverter-battery",
        name: "Inverter Battery",
        description:
            "Power backup battery solutions designed for reliable everyday use.",
        cta: "Enquire Now",
        art: "battery",
        accent: "#00CFFF",
        category: "Power Backup",
    },
    {
        id: "lithium-battery",
        name: "Lithium Battery",
        description:
            "Modern battery technology for efficient and reliable energy storage.",
        cta: "Enquire Now",
        art: "lithium",
        accent: "#00CFFF",
        category: "Power Backup",
    },
    {
        id: "solar-panels",
        name: "Solar Panels",
        description: "Harness solar energy with modern solar panel solutions.",
        cta: "Get Solar Quote",
        art: "solar",
        accent: "#FFD21F",
        category: "Solar",
    },
    {
        id: "complete-solar-setup",
        name: "Complete Solar Setup",
        description:
            "Complete solar solutions including panel setup and related installation requirements.",
        cta: "Get Solar Quote",
        art: "solarSetup",
        accent: "#FFD21F",
        category: "Solar",
    },
    {
        id: "cctv-cameras",
        name: "CCTV Cameras",
        description:
            "Security camera solutions for homes, shops, offices and other properties.",
        cta: "Enquire Now",
        art: "cctv",
        accent: "#126EFF",
        category: "Security",
    },
    {
        id: "broadband-connection",
        name: "Broadband Connection",
        description:
            "Reliable broadband connectivity solutions for homes and businesses.",
        cta: "Get Connection",
        art: "broadband",
        accent: "#126EFF",
        category: "Connectivity",
    },
    {
        id: "ev-chargers",
        name: "EV Chargers & E-Bikes",
        description:
            "Smarten EV chargers, lithium EV batteries and Cykal electric bikes.",
        cta: "Enquire Now",
        art: "ev",
        accent: "#00CFFF",
        category: "EV",
    },
];

export const SERVICES = [
    {
        icon: "battery",
        title: "Power Backup Solutions",
        description: "Inverter, battery and lithium battery solutions.",
    },
    {
        icon: "sun",
        title: "Solar Solutions",
        description: "Solar panel and complete solar setup solutions.",
    },
    {
        icon: "video",
        title: "CCTV Solutions",
        description: "CCTV camera supply and installation-related services.",
    },
    {
        icon: "wifi",
        title: "Broadband Services",
        description: "Broadband connectivity solutions.",
    },
    {
        icon: "wrench",
        title: "Installation & Support",
        description: "Professional assistance for relevant products and setups.",
    },
];

export const WHY_US = [
    { icon: "zap", title: "Reliable Solutions" },
    { icon: "battery", title: "Power Backup Expertise" },
    { icon: "sun", title: "Solar Solutions" },
    { icon: "shield", title: "Security Solutions" },
    { icon: "globe", title: "Connectivity Solutions" },
    { icon: "handshake", title: "Customer Focused" },
];

export const PROCESS_STEPS = [
    {
        num: "01",
        title: "Contact Us",
        description: "Call 9933719744 or send an enquiry.",
    },
    {
        num: "02",
        title: "Discuss Your Requirement",
        description: "Tell us what product or solution you need.",
    },
    {
        num: "03",
        title: "Get the Right Solution",
        description: "Receive suitable product/service information.",
    },
    {
        num: "04",
        title: "Get Started",
        description: "Proceed with the selected solution.",
    },
];

export const SERVICE_OPTIONS = [
    "Smarten Inverter",
    "Inverter Battery",
    "Lithium Battery",
    "Solar Panel",
    "Complete Solar Setup",
    "CCTV Camera",
    "Broadband Connection",
    "EV Charger",
    "Other",
];

export const MARQUEE_ITEMS = [
    "POWER BACKUP",
    "SOLAR ENERGY",
    "CCTV SECURITY",
    "BROADBAND",
    "INSTALLATION & SUPPORT",
    "HOME & BUSINESS",
];
